
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shyftpass",
      function () {
        return require("private-next-pages/shyftpass/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shyftpass"])
      });
    }
  